module.exports = __webpack_public_path__ + "media/images/favicon-85e14904a66b536590ac311d063d167e.png";